import React from 'react';
import { Beacon } from 'types/beacon';
import { getValueSafely } from 'utils/utils';

export default function LocationSpan({ beacon }: { beacon: Beacon }) {

  const buildingNamesArray = beacon.location?.building_level?.possible_buildings || [];
  const buildingName = getValueSafely(buildingNamesArray[0]?.name);
  const buildingLevelName = getValueSafely(beacon.location?.building_level?.level.name);

  return <span style={{ marginBottom: '10px' }}>{`${buildingLevelName}/${buildingName}`}</span>;
}
